import { forwardRef } from 'react';
import Button from '@ebsco-ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from '@ebsco-ui/tooltip';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import cn from 'classnames';
import { jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["title", "selectedTitle", "onClick", "isSelected", "defaultIcon", "selectedIcon", "className", "tooltipProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ToolButton = forwardRef(function (_ref, ref) {
  var title = _ref.title,
      selectedTitle = _ref.selectedTitle,
      onClick = _ref.onClick,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      defaultIcon = _ref.defaultIcon,
      selectedIcon = _ref.selectedIcon,
      className = _ref.className,
      _ref$tooltipProps = _ref.tooltipProps,
      tooltipProps = _ref$tooltipProps === void 0 ? {} : _ref$tooltipProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  var getBlocksWith = createBemBlockBuilder(["eb-tool-button", className]);
  var toolIcon = isSelected && selectedIcon || defaultIcon;
  var toolTitle = isSelected && selectedTitle || title;
  return /*#__PURE__*/jsx("div", {
    className: getBlocksWith(),
    children: /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({
      className: getBlocksWith("__tooltip"),
      title: toolTitle
    }, tooltipProps), {}, {
      children: /*#__PURE__*/jsx(Button, _objectSpread(_objectSpread({
        className: cn(getBlocksWith("__button"), isSelected && getBlocksWith("__button--selected")),
        styleType: "flat-icon",
        onClick: onClick,
        "data-auto": "tool-button",
        "aria-label": toolTitle,
        ref: ref
      }, rest), {}, {
        children: /*#__PURE__*/jsx(FontAwesomeIcon, {
          className: getBlocksWith("__icon"),
          icon: toolIcon,
          "data-auto": "font-awesome-icon"
        })
      }))
    }))
  });
});
ToolButton.displayName = "ToolButton";

export { ToolButton as default };
//# sourceMappingURL=tool-button-esm.js.map
